import axios from "axios";
import { loginreq, req, reqGet } from "../axiosFun";

// 查询模板演示分类
export const getCategoryList = params => {
  return reqGet("get", "/app-yijiu-backstage/getCategoryList", params);
};

// 删除模板演示分类
export const deleteCategory = params => {
  return reqGet("get", "/app-yijiu-backstage/deleteCategory", params);
};

// 增加模板演示分类
export const addCategory = params => {
  return req("post", "/app-yijiu-backstage/addCategory", params);
};

// 增加模板演示队伍
export const addCategoryTeam = params => {
  return req("post", "/app-yijiu-backstage/addCategoryTeam", params);
};

// 修改模板演示分类  
export const updateCategory = params => {
  return req("post", "/app-yijiu-backstage/updateCategory", params);
};

// 查询队伍
export const getHotTeamList = params => {
  return reqGet("get", "/app-yijiu-backstage/getHotTeamList", params);
};


// WEBPACK FOOTER //
// ./src/api/manage/category.js